<template>
  <v-card :elevation="0">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title>
          <img :src="imageSrc" alt="required" width="200" height="128"/>
        </v-list-item-title>
        <v-list-item-subtitle class="no-data">
          NO DATA
        </v-list-item-subtitle>
        <v-list-item-subtitle class="no-data-search" v-if="this.searchName">
          <p>{{ $t("nodata_search_eror") }} <br/> "{{ this.searchName }}"</p>
        </v-list-item-subtitle>
        <v-list-item-subtitle class="message-content">
          <a v-on:click="$emit('reload-event')">{{ $t("common_reloadData") }}</a>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: {
    tabAll: {
      type: String,
    },
    tabRequesting: {
      type: String,
    },
    tabMyList: {
      type: String,
    },
    searchName: {
      type: String,
    }
  },
  computed: {
    imageSrc() {
      if (this.tabAll) {
        return require('../../../assets/nodata_approved.png');
      } 
      if(this.tabMyList) {
        return require('../../../assets/nodata_mylist-img.png');
      }
      if (this.tabRequesting) {
        return require('../../../assets/nodata_inprogress.png');
      }
      return '';
    },
},
};
</script>

<style scoped>
.v-sheet.v-card {
  border-style: none !important;
  height: 100%;
  text-align: center;
  align-items: center;
  display: grid;
}

.no-data {
  font-size: 1.25rem;
  font-weight: bold;
  color: #c7c7c7;
}

.no-data-search{
  font-size: 15px;
  color: #c7c7c7;
  font-weight: normal;
  padding-top: 10px;
}

.message-content {
  font-size: 0.8.25rem;
  color: #c7c7c7;
  margin-top: 15px;
}
</style>
